import styled, { css } from 'styled-components'

import { textOverflowStyles } from 'common/styles/textOverflow'
import { BoxShadow, Colors } from 'common-constants/colors'
import { Button } from 'components/presentational/button'
import { RouterLink } from 'components/presentational/link'
import {
  Online,
  Verified,
} from 'components/presentational/photoStatus/PhotoStatus'

import noUserPhoto from '../images/noUserPhoto.svg'

export const landingLinkStyles = css`
  display: block;

  & + & {
    margin-top: 15px;
  }
`

export const LandingTitle = styled.h1`
  font-size: 26px;
  font-weight: bold;
  line-height: 1.15;
  margin: 6px 0 20px;
`

export const LandingUsersGrid = styled.div`
  display: grid;
  margin-top: 20px;
  grid-gap: 20px;
  grid-template-columns: repeat(4, 1fr);

  @media (min-width: 992px) and (max-width: 1350px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px 10px;
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const LandingUserCard = styled(RouterLink)`
  border-radius: 10px;
  overflow: hidden;
  box-shadow: ${BoxShadow.Default};

  ${Online}, ${Verified} {
    vertical-align: middle;
    margin: 0;
    ${(props) => props.theme.marginLeft}: 5px;
  }
`

export const UserCardImage = styled.div`
  height: 269px;
  background-color: ${Colors.replyMessage};
  background-image: url(${noUserPhoto});
  position: relative;
  background-size: 150px 150px;
  background-position: center center;
  background-repeat: no-repeat;

  @media (max-width: 480px) {
    height: 180px;
  }
`

export const Photo = styled.img`
  object-fit: cover;
  object-position: center center;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
`

export const UserCardSubtitle = styled.p`
  font-size: 12px;
  color: ${Colors.location};
  margin: 0;
`

export const UserCardTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.13;
  margin: 0;
  color: var(--static-black);

  span {
    display: inline-block;
    vertical-align: middle;
  }

  + ${UserCardSubtitle} {
    margin-top: 5px;
  }
`

export const UserCardDescription = styled.div`
  padding: 10px;
`

export const LandingSection = styled.section`
  border-radius: 10px;
  box-shadow: ${BoxShadow.BorderLight};
  margin: 20px 0;
  padding: 20px;
  font-size: 13px;
  line-height: 1.23;

  @media (max-width: 480px) {
    padding: 10px;
  }
`

export const LandingColumns = styled.div<{
  $columns?: number
  $columnGap?: number
}>`
  line-height: inherit;
  columns: ${(props) => props.$columns || 2};
  column-gap: ${(props) => props.$columnGap || 40}px;

  @media (max-width: 640px) {
    columns: 2;
  }

  @media (max-width: 480px) {
    columns: 1;
  }
`

export const LandingSectionTitle = styled.h3`
  font-size: 16px;
  line-height: 1;
  margin: 0 0 20px;

  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
`

export const LandingBannerPicture = styled.img`
  position: absolute;
  ${(props) => props.theme.left}: 0;

  top: 0;
  z-index: -1;
  width: 100%;
  background-color: ${Colors.landingBanner};
  border-radius: 10px;
  object-fit: cover;
  min-height: 210px;
`

export const LandingRouterLink = styled(RouterLink)`
  ${landingLinkStyles}
`

export const LandingBannerTitle = styled.h2`
  font-size: 26px;
  font-weight: bold;
  line-height: 1.15;
  color: var(--static-white);
  margin: 0 0 30px;

  @media (max-width: 640px) {
    font-size: 20px;
  }
`

export const LandingBannerButton = styled(Button)`
  max-width: 260px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`

export const LandingInnerContent = styled.div`
  padding: 20px 0;
  min-height: 520px;
`

export const LandingUserName = styled.span`
  vertical-align: middle;
  display: inline-block;
  max-width: calc(100% - 10px);
  ${textOverflowStyles};
`

export const LandingUserAge = styled.span`
  vertical-align: middle;
  display: inline-block;
  ${(props) => props.theme.marginLeft}: 5px;
`

export const LandingColumnsParagraph = styled.p`
  margin: 0;

  & + & {
    margin-top: 10px;
  }
`
